import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import { ContextProvider } from './Context';
import Main from './Main';

export default function Index({
  enterpriseId, policyEnabled, currency, currencyId,
}) {
  return (
    <StrictMode>
      <UsersContextProvider>
        <ContextProvider enterpriseId={enterpriseId} currency={currency} currencyId={currencyId}>
          <Main enterpriseId={enterpriseId} policyEnabled={policyEnabled} />
        </ContextProvider>
      </UsersContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  policyEnabled: PropTypes.bool,
  currency: PropTypes.string,
  currencyId: PropTypes.string.isRequired,
};

Index.defaultProps = {
  policyEnabled: true,
  currency: 'USD',
};
